// export const BASE_URL = "https://laravel-admin-api.triamiz.in/";
// export const BASE_URL = "http://localhost:8000/";
export const BASE_URL = "https://ecom360.dev.semi360.ai/";
export const API_URL = `${BASE_URL}api`;

export const END_POINT = {
  LOGIN: `${API_URL}/login`,
  REFRESH_PASSWORD: `${API_URL}/refresh-token`,
  MENUS: `${API_URL}/menus`,
  MODULES: `${API_URL}/modules`,
  FORGOT_PASSWORD: `${API_URL}/forgot-password`,

  ADMIN_FILTERLIST_UPDATE: `${API_URL}/update-filter-list`,

  DASHBOARD: `${API_URL}/dashboard`,

  RESET_PASSWORD: `${API_URL}/profile/edit/password`,
  PROFILE_UPDATE: `${API_URL}/profile/edit`,

  // INFO: COMMON API'S
  FILE_UPLOAD: `${API_URL}/upload/file`,
  IMAGE_UPLOAD: `${API_URL}/upload/image-file`,

  SETTINGS: `${API_URL}/system/settings`,
  SETTING_CREATE: `${API_URL}/system/settings/create`,
  SETTING_EDIT: `${API_URL}/system/settings/edit/`,
  SETTING_DELETE: `${API_URL}/system/settings/delete`,
  LOG_FILE_EXPORT: `${API_URL}/system/settings/download-log`,

  MENU_ITEMS: `${API_URL}/system/menu-items`,
  MENU_ITEM_LIST: `${API_URL}/system/menu-items/list`,
  MENU_ITEMS_CREATE: `${API_URL}/system/menu-items/create`,
  MENU_ITEMS_EDIT: `${API_URL}/system/menu-items/edit/`,
  MENU_ITEMS_DELETE: `${API_URL}/system/menu-items/delete`,
  MENU_ITEMS_STATUS_TOGGLE: `${API_URL}/system/menu-items/status-toggle`,
  MENU_ITEMS_EXPORT: `${API_URL}/system/menu-items/export`,
  MENU_ITEMS_READ_FILE: `${API_URL}/system/menu-items/read`,
  MENU_AUTO_COMPLETE: `${API_URL}/menus/autocomplete`,
  SUB_MENU_ITEM_LIST: `${API_URL}/system/menu-items/sub/list/`,

  USERS: `${API_URL}/user-administration/users`,
  USER_CREATE: `${API_URL}/user-administration/users/create`,
  USER_EDIT: `${API_URL}/user-administration/users/edit/`,
  USER_DELETE: `${API_URL}/user-administration/users/delete`,
  USER_STATUS_TOGGLE: `${API_URL}/user-administration/users/status-toggle`,
  ALL_USERS: `${API_URL}/user-administration/users/list`,
  USERS_LIST: `${API_URL}/user/list`,

  USERS_LOG: `${API_URL}/user-administration/user-log`,
  USERS_LOG_DELETE: `${API_URL}/user-administration/user-log/delete`,

  All_ROLES: `${API_URL}/user-administration/roles/all`,
  ROLES: `${API_URL}/user-administration/roles`,
  ROLE_CREATE: `${API_URL}/user-administration/roles/create`,
  ROLE_EDIT: `${API_URL}/user-administration/roles/edit`,
  ROLE_DELETE: `${API_URL}/user-administration/roles/delete`,

  ALL_MENUS: `${API_URL}/system/menu-items/get-all`,

  EMAIL_TEMPLATE_LIST: `${API_URL}/system/email-template`,
  EMAIL_TEMPLATE_CREATE: `${API_URL}/system/email-template/create`,
  EMAIL_TEMPLATE_EDIT: `${API_URL}/system/email-template/edit/`,
  EMAIL_TEMPLATE_DELETE: `${API_URL}/system/email-template/delete`,
  EMAIL_TEMPLATE_UPLOAD: `${API_URL}/system/email-template/upload-template`,
  EMAIL_TEMPLATE_STATUS_TOGGLE: `${API_URL}/system/email-template/status-toggle`,
  EMAIL_TEMPLATE_DEFAULT_TOGGLE: `${API_URL}/system/email-template/default-toggle`,

  BLOCKED_IP_LIST: `${API_URL}/system/blocked-ip`,
  BLOCKED_IP_CREATE: `${API_URL}/system/blocked-ip/create`,
  BLOCKED_IP_EDIT: `${API_URL}/system/blocked-ip/edit/`,
  BLOCKED_IP_DELETE: `${API_URL}/system/blocked-ip/delete`,

  SMS_TEMPLATE_LIST: `${API_URL}/system/sms-template`,
  SMS_TEMPLATE_CREATE: `${API_URL}/system/sms-template/create`,
  SMS_TEMPLATE_EDIT: `${API_URL}/system/sms-template/edit/`,
  SMS_TEMPLATE_DELETE: `${API_URL}/system/sms-template/delete`,
  SMS_TEMPLATE_STATUS_TOGGLE: `${API_URL}/system/sms-template/status-toggle`,

  DATABASE_BACKUP_LIST: `${API_URL}/system/database-backup`,
  DATABASE_BACKUP_CREATE: `${API_URL}/system/database-backup/create`,
  DATABASE_BACKUP_DELETE: `${API_URL}/system/database-backup/delete`,
  DATABASE_BACKUP_EXPORT: `${API_URL}/system/database-backup/export/file`,

  MODULES_LIST: `${API_URL}/system/modules`,
  MODULES_CREATE: `${API_URL}/system/modules/create`,
  MODULES_EDIT: `${API_URL}/system/modules/edit/`,
  MODULES_DELETE: `${API_URL}/system/modules/delete`,
  MODULES_STATUS_TOGGLE: `${API_URL}/system/modules/status-toggle`,
  MODULES_ALL_LIST: `${API_URL}/system/modules/list`,

  SENT_EMAIL_LIST: `${API_URL}/reports/sent-email`,
  SENT_EMAIL_DELETE: `${API_URL}/reports/sent-email/delete`,
  SENT_EMAIL_STATUS_TOGGLE: `${API_URL}/reports/sent-email/status-toggle`,

  SENT_SMS_LIST: `${API_URL}/reports/sent-sms`,
  SENT_SMS_DELETE: `${API_URL}/reports/sent-sms/delete`,
  SENT_SMS_STATUS_TOGGLE: `${API_URL}/reports/sent-sms/status-toggle`,

  NOTIFICATION_LIST: `${API_URL}/user-administration/notification`,
  NOTIFICATION_CREATE: `${API_URL}/user-administration/notification/create`,
  NOTIFICATION_EDIT: `${API_URL}/user-administration/notification/edit/`,
  NOTIFICATION_DELETE: `${API_URL}/user-administration/notification/delete`,
  NOTIFICATION_STATUS_TOGGLE: `${API_URL}/user-administration/notification/status-toggle`,
  NOTIFICATION_LIST_COUNT: `${API_URL}/user-administration/notification/get/notification`,
  NOTIFICATION_LIST_COUNT_UPDATE: `${API_URL}/user-administration/notification/app/edit/`,

  FAVORITE_MENU_LIST: `${API_URL}/system/favorite-menu/app/list`,
  FAVORITE_MENU_CREATE: `${API_URL}/system/favorite-menu/app/create`,
  FAVORITE_MENU_DELETE: `${API_URL}/system/favorite-menu/app/delete`,

  BUG_LIST: `${API_URL}/bug-tracker`,
  BUG_CREATE: `${API_URL}/bug-tracker/create`,
  BUG_EDIT: `${API_URL}/bug-tracker/edit/`,
  BUG_DELETE: `${API_URL}/bug-tracker/delete`,
  BUG_UPLOAD: `${API_URL}/bug-tracker/upload-files`,
  BUG_STATUS_LIST: `${API_URL}/bug-tracker/list/bugs-by-status/`,
  BUG_VERSION_LIST: `${API_URL}/bug-tracker/list/bugs-by-versionId/`,
  BUG_TRACKER_STATUS_TOGGLE: `${API_URL}/bug-tracker/status-toggle`,
  BUG_EXPORT: `${API_URL}/bug-tracker/export-csv`,

  VERSION_LIST: `${API_URL}/version`,
  VERSION_CREATE: `${API_URL}/version/create`,
  VERSION_EDIT: `${API_URL}/version/edit/`,
  VERSION_DELETE: `${API_URL}/version/delete`,

  BUG_COMMENTS_LIST: `${API_URL}/bug-comments`,
  BUG_COMMENTS_CREATE: `${API_URL}/bug-comments/create`,

  INVENTORY_CATEGORY_LIST: `${API_URL}/inventory/category`,
  INVENTORY_CATEGORY_CREATE: `${API_URL}/inventory/category/create`,
  INVENTORY_CATEGORY_EDIT: `${API_URL}/inventory/category/edit/`,
  INVENTORY_CATEGORY_DELETE: `${API_URL}/inventory/category/delete`,

  INVENTORY_ITEMS_LIST: `${API_URL}/inventory/items`,
  INVENTORY_ITEMS_CREATE: `${API_URL}/inventory/items/create`,
  INVENTORY_ITEMS_EDIT: `${API_URL}/inventory/items/edit/`,
  INVENTORY_ITEMS_DELETE: `${API_URL}/inventory/items/delete`,
  INVENTORY_ITEMS_UPLOAD: `${API_URL}/inventory/items/upload-file`,
  INVENTORY_ITEMS_SAMPLE_DOWNLOAD: `${API_URL}/inventory/items/download-sample-file`,
  INVENTORY_ITEMS_SAMPLE_DOWNLOAD_WITHOUT_SPECS: `${API_URL}/inventory/items/download-without-specs`,
  INVENTORY_CATEGORY_ITEMS_LIST: `${API_URL}/inventory/items/list`,
  INVENTORY_MANUFACTURER_ITEMS_LIST: `${API_URL}/inventory/manufacturer/list`,

  INVENTORY_FILE_UPLOAD_LIST: `${API_URL}/inventory/file-uploads`,
  INVENTORY_FILE_UPLOAD_CREATE: `${API_URL}/inventory/file-uploads/create`,
  INVENTORY_FILE_UPLOAD_EDIT: `${API_URL}/inventory/file-uploads/edit/`,
  INVENTORY_FILE_UPLOAD_DELETE: `${API_URL}/inventory/file-uploads/delete`,

  INVENTORY_MANUFACTURER_LIST: `${API_URL}/inventory/manufacturers`,
  INVENTORY_MANUFACTURER_CREATE: `${API_URL}/inventory/manufacturers/create`,
  INVENTORY_MANUFACTURER_EDIT: `${API_URL}/inventory/manufacturers/edit/`,
  INVENTORY_MANUFACTURER_DELETE: `${API_URL}/inventory/manufacturers/delete`,
  INVENTORY_MANUFACTURER_UPLOAD: `${API_URL}/inventory/manufacturers/upload-file`,

  CUSTOMER_LIST: `${API_URL}/customers/list`,
  CUSTOMER_CREATE: `${API_URL}/customers/create`,
  CUSTOMER_EDIT: `${API_URL}/customers/edit/`,
  CUSTOMER_DELETE: `${API_URL}/customers/delete`,

  PROMO_CODE_LIST: `${API_URL}/promo-code/list`,
  PROMO_CODE_CREATE: `${API_URL}/promo-code/create`,
  PROMO_CODE_EDIT: `${API_URL}/promo-code/edit/`,
  PROMO_CODE_DELETE: `${API_URL}/promo-code/delete`,

  PRODUCTS_LIST: `${API_URL}/products/list`,
  PRODUCTS_CREATE: `${API_URL}/products/create`,
  PRODUCTS_EDIT: `${API_URL}/products/edit/`,
  PRODUCTS_DELETE: `${API_URL}/products/delete`,
  PRODUCTS_AUTO_COMPLETE: `${API_URL}/products/auto-complete`,

  BANNER_LIST: `${API_URL}/design/banners/list`,
  BANNER_CREATE: `${API_URL}/design/banners/create`,
  BANNER_EDIT: `${API_URL}/design/banners/edit/`,
  BANNER_DELETE: `${API_URL}/design/banners/delete`,
  BANNER_UPLOAD: `${API_URL}/design/banners/upload-image`,


  ORDER_LIST: `${API_URL}/account/order/list`,
  ORDER_EDIT: `${API_URL}/account/order/edit/`,
  ORDER_DELETE: `${API_URL}/account/order/delete`,

  SITE_SETTINGS_LIST: `${API_URL}/settings/site-settings/list`,
  SITE_SETTINGS_CREATE: `${API_URL}/settings/site-settings/create`,
  SITE_SETTINGS_EDIT: `${API_URL}/settings/site-settings/edit/`,
  SITE_SETTINGS_DELETE: `${API_URL}/settings/site-settings/delete`,

  PAGES_LIST: `${API_URL}/pages/list`,
  PAGES_CREATE: `${API_URL}/pages/create`,
  PAGES_EDIT: `${API_URL}/pages/edit/`,
  PAGES_DELETE: `${API_URL}/pages/delete`,

  MANUFACTURES_LIST: `${API_URL}/category-list`,
  
};
